<div class="_fake custom-scrollbar"
     #fake
     (scroll)="onFakeScroll($event)">
    <div class="_fakeInner"></div>
</div>
<div #real
     (scroll)="onScroll($event)"
     class="_outer _no-scrollbar">
    <div class="_inner"
         #inner>
        <ng-content></ng-content>
    </div>
</div>
